// Helper do BreadcrumbList JSON-LD (schema.org) — jeden punkt prawdy dla wszystkich
// landingów, żeby uniknąć copy-paste i mieć spójny format ścieżki nawigacyjnej.
export interface BreadcrumbItem {
  name: string;
  /** Pełna ścieżka WZGLĘDEM domeny, zaczynająca się od „/". Bez slasha na końcu. */
  path: string;
}

const ORIGIN = "https://tanielatanie.pl";

/**
 * Buduje obiekt `<script type="application/ld+json">` z BreadcrumbList do wstrzyknięcia
 * w `head().scripts`. Ostatni element powinien być stroną bieżącą.
 */
export function breadcrumbScript(items: BreadcrumbItem[]): {
  type: "application/ld+json";
  children: string;
} {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: `${ORIGIN}${it.path}`,
      })),
    }),
  };
}
